import { useEffect } from 'react';

const Sidebar = ({ currentStep, completedSteps, isMobileOpen, onClose, totalSteps = 9 }) => {
  const steps = Array.from({ length: totalSteps }, (_, i) => i + 1);

  useEffect(() => {
    if (isMobileOpen) {
      document.body.classList.add('mobile-menu-open');
    } else {
      document.body.classList.remove('mobile-menu-open');
    }
    return () => document.body.classList.remove('mobile-menu-open');
  }, [isMobileOpen]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) onClose();
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [onClose]);

  const SidebarContent = () => (
    <div className="flex flex-col items-center py-6 px-4">
      <div className="flex flex-col items-center space-y-6">
        {steps.map((stepNum) => {
          const isCompleted = completedSteps.includes(stepNum);
          const isCurrent = currentStep === stepNum;
          const isActive = isCompleted || isCurrent;
          return (
            <div key={stepNum} className="flex flex-col items-center">
              <div
                className={`w-[60px] h-[60px] rounded-full flex items-center justify-center font-lato font-medium text-[18px] transition-colors border-2 ${
                  isActive
                    ? 'bg-[#FF8E1C] text-white border-[#FF8E1C]'
                    : 'bg-white text-black border-[#FF8E1C]'
                }`}
              >
                {String(stepNum).padStart(2, '0')}
              </div>
              <span
                className={`mt-2 font-lato font-medium text-[16px] leading-[150%] ${
                  isActive ? 'text-[#FF8E1C]' : 'text-black'
                }`}
              >
                Step {stepNum}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop: horizontal step bar */}
      <div className="hidden md:flex items-start justify-between overflow-x-auto pb-2 mb-8 gap-1">
        {steps.map((stepNum) => {
          const isCompleted = completedSteps.includes(stepNum);
          const isCurrent = currentStep === stepNum;
          const isActive = isCompleted || isCurrent;
          return (
            <div key={stepNum} className="flex flex-col items-center flex-1 min-w-[44px]">
              <div
                className={`w-10 h-10 flex items-center justify-center rounded-full font-lato font-semibold text-base mb-1 transition-all ${
                  isActive
                    ? 'bg-[#FF8E1C] text-white shadow-[0_2px_5px_rgba(255,142,28,0.4)]'
                    : 'bg-white text-[#A0A3BD] border border-[#E0E0E0] shadow-[0_3px_6px_#D9D9D9]'
                }`}
              >
                {stepNum}
              </div>
              <span className="text-sm font-lato text-black whitespace-nowrap">
                Step {stepNum}
              </span>
            </div>
          );
        })}
      </div>

      {/* Mobile: sliding overlay sidebar */}
      {isMobileOpen && (
        <div className="mobile-sidebar-overlay" onClick={onClose}>
          <div
            className="mobile-sidebar-container w-[240px] h-full bg-[#FFF6EB]"
            onClick={(e) => e.stopPropagation()}
          >
            <SidebarContent />
          </div>
        </div>
      )}
    </>
  );
};

export default Sidebar;
